module.exports = __webpack_public_path__ + "static/media/3-Y.506fe3f2.mp3";